import { paths } from '../../common/constants/pathVariables.js';
import { myOrdersMsg, t } from '../../common/i18n/index.js';
import { HeroHeading, HeroHeadingType } from '../HeroHeading/index.js';
import { LocalNavi } from '../LocalNavi/index.js';

export const EoeMyOrdersBreadcrumb = () => {
  return (
    <HeroHeading
      heroHeadingType={HeroHeadingType.EMPLOYEE_ORDERS}
      title={t.EG6F(myOrdersMsg)}
      fullScreen={true}
      center={true}
    />
  );
};

export const EoeMyOrdersNavi = () => {
  return (
    <LocalNavi
      categories={[
        {
          children: t.PLW9('My Orders'),
          to: paths.EMPLOYEE_OWN_ORDERS,
        },
        {
          children: t.ZB3L('My redeem requests'),
          to: paths.EMPLOYEE_OWN_CHANGE_REQUESTS,
        },
      ]}
    />
  );
};
